import { DialogProps } from "@minuthq/meatball-ui-react"

import { MDialog } from "src/ui/Dialog/MDialog"

//TODO: WEB-429 add translations to default strings like ok and cancel.
export function ConfirmDialog(props: Omit<DialogProps, "hideClose">) {
  return <MDialog responsive={false} {...props} />
}
